<template>
  <!-- <div class="mainAct d-flex hideBlock customShow"> -->
  <div class="mainAct d-flex customShow hideBlock">
    <app-loader v-if="pageLoader" />
    <app-buy-sell v-if="tradeBuySell" :buySellType="buySellType"></app-buy-sell>
    <div class="act_web_dash calculateWidth portfoliyoPage">
      <div class="d-flex splitTop">
        <div class="first-wishlist">
          <div
            class="headerTitle d-flex align-items-center justify-content-between mb-3 p-2 border-bottom"
          >
            <h6>{{$t('summary')}}</h6>
            <a class="iconResize" href="#"><i class="icon-resize"></i></a>
          </div>
          <div class="wishlistTable scrollbar portFolioScroll">
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p class="mb-0">{{$t('net_profit')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.net_pl"
                :class="[
                  {
                    red: parseFloat(portfolioData.summary.net_pl || 0) < 0,
                    green: parseFloat(portfolioData.summary.net_pl || 0) > 0,
                  },
                ]"
              >
                {{ formatCurrency(parseFloat(portfolioData.summary.net_pl), accBalance.ACCOUNT_CURRENCY) }}
              </p>
              <p class="valurTR" v-else>0</p>
            </div>
            <!-- <div class="d-flex justify-content-between align-items-center profitMain">
		          			<p>Profit Margin</p>
		          			<p class="valurTR green">-</p>
		          		</div> -->
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('maximum_equity_drawdown')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.min_pl"
                :class="[
                  {
                    red: parseFloat(portfolioData.summary.min_pl || 0) < 0,
                    green: parseFloat(portfolioData.summary.min_pl || 0) > 0,
                  },
                ]"
              >
                {{ formatCurrency(parseFloat(portfolioData.summary.min_pl), accBalance.ACCOUNT_CURRENCY) }}
              </p>
              <p class="valurTR" v-else>0</p>
            </div>
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('profit_percentage')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.profit_pct"
                :class="[
                  {
                    red: parseFloat(portfolioData.summary.profit_pct || 0) < 0,
                    green: parseFloat(portfolioData.summary.profit_pct || 0) > 0,
                  },
                ]"
              >
                {{ parseFloat(portfolioData.summary.profit_pct) }}%
              </p>
              <p class="valurTR" v-else>0</p>
            </div>
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('opening_balance')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.opening_balance"
              >
                {{ formatCurrency(parseFloat(portfolioData.summary.opening_balance), accBalance.ACCOUNT_CURRENCY) }}
              </p>
              <p class="valurTR" v-else>0</p>
            </div>
            <!-- <div class="d-flex justify-content-between align-items-center profitMain">
		          			<p>Current Balance</p>
		          		<p class="valurTR" v-if="portfolioData.summary && portfolioData.summary.balance">-</p> 
		          			<p class="valurTR" v-if="portfolioData.summary && portfolioData.summary.opening_equity">{{portfolioData.summary.opening_equity}}</p>
		          			<p class="valurTR" v-else>0</p>
		          		</div> -->
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('open_equity')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.balance"
              >
                <!-- {{formatCurrency((parseFloat(accBalance.AMOUNT || 0) + parseFloat(gelGrossPL || 0)).toFixed(getPrecisionValue()), accBalance.ACCOUNT_CURRENCY)}} -->
                {{formatCurrency((parseFloat(portfolioData.summary.opening_equity || 0)).toFixed(getPrecisionValue()), accBalance.ACCOUNT_CURRENCY)}}
              </p>
              <p class="valurTR" v-else>0</p>
            </div>
            <!-- <div class="d-flex justify-content-between align-items-center profitMain">
              <p>Margin Used</p>
              <p class="valurTR">
                {{ formatCurrency(parseFloat(accBalance.ACCOUNT_USED_MARGIN || 0), accBalance.ACCOUNT_CURRENCY) }}
              </p>
            </div> -->
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('deposit')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.deposit"
              >
                {{ formatCurrency(parseFloat(portfolioData.summary.deposit), accBalance.ACCOUNT_CURRENCY) }}
              </p>
              <p class="valurTR" v-else>0.00</p>
            </div>
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('withdrawal')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.withdrawal"
              >
                {{ formatCurrency(parseFloat(portfolioData.summary.withdrawal), accBalance.ACCOUNT_CURRENCY) }}
              </p>
              <p class="valurTR" v-else>0.00</p>
            </div>
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('balance')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.balance"
              >
                {{ formatCurrency(parseFloat(portfolioData.summary.balance), accBalance.ACCOUNT_CURRENCY) }}
              </p>
              <p class="valurTR" v-else>0</p>
            </div>
            <div class="d-flex justify-content-between align-items-center profitMain">
              <p>{{$t('bonus')}}</p>
              <p
                class="valurTR"
                v-if="portfolioData.summary && portfolioData.summary.balance"
              >
                {{ formatCurrency(parseFloat(portfolioData.summary.bonus), accBalance.ACCOUNT_CURRENCY) }}
              </p>
              <p class="valurTR" v-else>0</p>
            </div>
          </div>
        </div>
        <!--Main Chart -->
        <div id="b" class="split content split-horizontal second-wishlist">
          <!-- <app-buy-sell v-show="tradeBuySell" :buySellType="buySellType"></app-buy-sell> -->
          <!-- <app-alerpop v-if="alertTab == 'alert'"></app-alerpop> -->

          <div class="chartRatio">
            <div
              class="charTab bottomInc d-flex justify-content-end border-top scrollbar"
            >
              <div class="leftMotnh d-flex align-items-center pl-2">
                <!-- <a class="d-flex align-items-center justify-content-center arrowDown" href="#"><feather  size="18px" type="chevron-down"></feather> </a> -->
                <p class="d-flex align-items-center m-0">
                  <a
                    class="white"
                    @click.prevent="currentInterval = item.value"
                    href="#"
                    v-for="item in interval"
                    :class="[{ active: currentInterval == item.value }]"
                  >
                    <span>{{ item.value }}</span>
                  </a>
                </p>
              </div>
            </div>
            <div class="d-flex border-top calHight">
              <div class="chartMap">
                <div id="equityBalanceChartDiv" style="height: 100%"></div>

                <!-- <img class="portBalance-graph" src="../../../../static/website/images/graphSide7.svg" alt="Icon">	 -->
              </div>
            </div>
          </div>
        </div>
        <!--split_b-->
        <!--Main Chart Close-->
      </div>
      <div class="orderTab-bottom performance-tab-scroll-able">
        <div
          class="topHead d-flex justify-content-between align-items-center border-bottom"
        >
          <ul class="tbs d-flex">
            <li :class="order == 'Performance' ? 'active' : ' '">
              <a @click.prevent="order = 'Performance'" href="#">{{$t('performance') }} </a>
            </li>
            <!-- <li :class="(order == 'Volume')?'active':' '">
							<a @click.prevent="order = 'Volume' " href="#">Volume</a>
						</li> -->
            <li :class="order == 'Profitability' ? 'active' : ' '">
              <a @click.prevent="order = 'Profitability'" href="#">{{$t('profitability') }} </a>
            </li>
          </ul>
          <!-- <div class="rightMonth">
						<p class="d-flex align-items-center m-0">
							<a href="#" class="white"><span>1d</span></a> 
							<a href="#" class="white"><span>5d</span></a> 
							<a href="#" class="white"><span>1m</span></a> 
							<a href="#" class="white"><span>3m</span></a> 
							<a href="#" class="white"><span>6m</span></a> 
							<a href="#" class="white"><span>1y</span></a> 
							<a href="#" class="white"><span>5 Year</span></a> 
							<a href="#" class="white"><span>Max</span></a>
						</p>
					</div> -->
        </div>
        <div
          class="responsiveTable scrollbar bottomTable"
          v-show="order == 'Performance'"
        >
          <div class="mainPerformance d-flex">
            <ul class="listTotal">
              <li>
                {{$t('total_trading_volume') }}  <span>{{ parseFloat(volumeSum).toFixed(2) }}</span>
              </li>
              <li>
                {{$t('avg_trade_size') }} 
                <span>{{ parseFloat(volumeSum / tradeCount).toFixed(2) }}</span>
              </li>
              <li>
                {{$t('total_trades') }} <span>{{ tradeCount }}</span>
              </li>

              <li>
                {{$t('trades_won') }} 
                <span class="d-flex align-items-center"
                  >{{ totalPositive
                  }}<span class="green ml-1"
                    >({{
                      parseFloat((totalPositive / tradeCount) * 100).toFixed(2)
                    }}
                    %)</span
                  ></span
                >
              </li>
              <li>
                {{$t('trades_lost') }}  
                <span class="d-flex align-items-center"
                  >{{ totalNegative
                  }}<span class="red ml-1"
                    >({{
                      parseFloat((totalNegative / tradeCount) * 100).toFixed(2)
                    }}
                    %)</span
                  ></span
                >
              </li>
            </ul>
            <div class="rightGraph position-relative">
              <div class="bottomGRaph">
                <!-- <div class="absoluteGraph skydarkBG d-flex align-items-center">
									<div class="dropdown mr-4">
									  <button type="button" class="btn appButton dropdown-toggle" data-toggle="dropdown">
									    Line
									  </button>
									  <div class="dropdown-menu">
									    <a class="dropdown-item" href="#">Line 1</a>
									    <a class="dropdown-item" href="#">Line 2</a>
									    <a class="dropdown-item" href="#">Line 3</a>
									  </div>
									</div>
									<div class="upTrade">
										<a href="#"><feather class="greenBG" size="17px" type="arrow-up"></feather> Trades Won</a>
									</div>
									<div class="upTrade downTrade">
										<a href="#"><feather class="redBG" size="17px" type="arrow-down"></feather> Trades Lost</a>
									</div>
								</div> -->
                <div id="performanceChartDiv" style="height: 100%; width: 100%"></div>

                <!-- <img class="mainGraphImg" src="../../../../static/website/images/graphSide7.svg" alt="Icon"> -->
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="responsiveTable scrollbar bottomTable" v-if="order == 'Volume'">
	          		<table class="table table-hover">
						    <thead>
						      <tr>
						        <th>Asset</th>
						        <th>Volume</th>
						        <th>Volume%</th>
						        <th>Avg Trade Size</th>
						        <th>Trades</th>
						        <th>Winning</th>
						        <th>Lossing</th>
						      </tr>
						    </thead>
						    <tbody>
						      <tr>
						        <td>GBP-USD</td>
						        <td>$12070.12</td>
						        <td>62.47%</td>
						        <td>$3022.53</td>
						        <td>7</td>
						        <td>3 <span class="green">(25%)</span></td>
						        <td>4 <span class="red">(75%)</span></td>
						      </tr>
						      <tr>
						        <td>GBP-USD</td>
						        <td>$12070.12</td>
						        <td>62.47%</td>
						        <td>$3022.53</td>
						        <td>7</td>
						        <td>3 <span class="green">(25%)</span></td>
						        <td>4 <span class="red">(75%)</span></td>
						      </tr>
						      <tr>
						        <td>GBP-USD</td>
						        <td>$12070.12</td>
						        <td>62.47%</td>
						        <td>$3022.53</td>
						        <td>7</td>
						        <td>3 <span class="green">(25%)</span></td>
						        <td>4 <span class="red">(75%)</span></td>
						      </tr>
						      <tr>
						        <td>GBP-USD</td>
						        <td>$12070.12</td>
						        <td>62.47%</td>
						        <td>$3022.53</td>
						        <td>7</td>
						        <td>3 <span class="green">(25%)</span></td>
						        <td>4 <span class="red">(75%)</span></td>
						      </tr>
						      <tr>
						        <td>GBP-USD</td>
						        <td>$12070.12</td>
						        <td>62.47%</td>
						        <td>$3022.53</td>
						        <td>7</td>
						        <td>3 <span class="green">(25%)</span></td>
						        <td>4 <span class="red">(75%)</span></td>
						      </tr>
						      <tr>
						        <td>GBP-USD</td>
						        <td>$12070.12</td>
						        <td>62.47%</td>
						        <td>$3022.53</td>
						        <td>7</td>
						        <td>3 <span class="green">(25%)</span></td>
						        <td>4 <span class="red">(75%)</span></td>
						      </tr>
						      
						    </tbody>
					</table>
		        </div> -->
        <div
          class="responsiveTable scrollbar bottomTable"
          v-show="order == 'Profitability'"
        >
          <table class="table table-hover">
            <thead>
              <tr>
                <th>{{$t('asset') }} </th>
                <th>{{$t('volume') }} </th>
                <th>{{$t('volume') }}%</th>
                <th>{{$t('avg_trade_size') }} </th>
                <th>{{$t('trades') }} </th>
                <th>{{$t('winning') }} </th>
                <th>{{$t('losing') }} </th>
              </tr>
            </thead>
            <tbody
              v-if="portfolioData.profitability && portfolioData.profitability.length > 0"
            >
              <tr v-for="list in portfolioData.profitability">
                <td>{{ list.instrument }}</td>
                <td>{{ list.volume }}</td>
                <td>{{ parseFloat((list.volume / volumeSum) * 100).toFixed(2) }}</td>
                <td>{{ parseFloat((list.count / tradeCount) * 100).toFixed(2) }}</td>
                <td>{{ list.count }}</td>
                <td>
                  {{ list.positive
                  }}<!-- 3 <span class="green">(25%)</span> -->
                </td>
                <td>
                  {{ list.negative
                  }}<!-- 4 <span class="red">(75%)</span> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "../../../../node_modules/@amcharts/amcharts4/core";
import * as am4charts from "../../../../node_modules/@amcharts/amcharts4/charts";
import * as am4maps from "../../../../node_modules/@amcharts/amcharts4/maps";
// import am4themes_animated from "../../../../node_modules/@amcharts/amcharts4/themes/animated"

// am4core.useTheme(am4themes_animated)
am4core.options.autoSetClassName = true;
am4core.options.commercialLicense = true;

import buy_sell from "../shared/buy-sell";
import news_popup from "../shared/news-popup";
import chart_section from "./home-elements/chart-section";
import buy_sell_tabing from "./home-elements/buy-sell-tabing";
import { commonAllmixins } from "@/plugins/commonAll";
import { Const } from "@/plugins/vue-provider-cache/const.mod";

import moment from "moment";
const product_type = process.env.product_type;
export default {
  name: "multi-view",
  mixins: [commonAllmixins],
  data() {
    return {
      pageLoader: false,
      currencyType: "ALL",
      order: "Performance",
      rightTabs: "watchlist",
      accordian: "1",
      newsType: false,
      indexNo: "",
      buyType: "Market",
      buySellType: "buy",
      technicals: "daily",
      page: "1",
      buySell: "",
      setUpFxaccount: false,
      advance: false,
      tradeBuySell: false,
      filterOption: false,
      currencyIcon: { EUR: "€", USD: "$", CAD: "CA$", BTC: "₿", GBP: "£", CHF: "CHF", JPY: "¥", AUD: "A$" },

      volumeSum: 0,
      tradeCount: 0,

      totalPositive: 0,
      totalNegative: 0,
      performanceChartData: {},
      interval: {
        "1d": {
          value: "1d",
          from_date: moment(new Date().setDate(new Date().getDate() - 1)).format(
            "YYYY-MM-DD"
          ),
        },
        "5d": {
          value: "5d",
          from_date: moment(new Date().setDate(new Date().getDate() - 5)).format(
            "YYYY-MM-DD"
          ),
        },
        "1m": {
          value: "1m",
          from_date: moment(new Date().setMonth(new Date().getMonth() - 1)).format(
            "YYYY-MM-DD"
          ),
        },
        "3m": {
          value: "3m",
          from_date: moment(new Date().setMonth(new Date().getMonth() - 3)).format(
            "YYYY-MM-DD"
          ),
        },
        "6m": {
          value: "6m",
          from_date: moment(new Date().setMonth(new Date().getMonth() - 6)).format(
            "YYYY-MM-DD"
          ),
        },
        "1y": {
          value: "1y",
          from_date: moment(new Date().setFullYear(new Date().getFullYear() - 1)).format(
            "YYYY-MM-DD"
          ),
        },
        "5Y": {
          value: "5 Year",
          from_date: moment(new Date().setFullYear(new Date().getFullYear() - 5)).format(
            "YYYY-MM-DD"
          ),
        },
      },
      currentInterval: "6m",
      xAxisColor:'#666666',
      yAxisColor:'#666666',
    };
  },
  components: {
    appBuySell: buy_sell,
    appNewspopup: news_popup,
    appChartsecssion: chart_section,
    AppBuyselltabing: buy_sell_tabing,
  },
  watch: {
    /*openTradeList(val) {
      this.getBalance();
    },*/
    currentInterval(val) {
      this.getPortfolioData();
    },
  },
  computed: {
    instruments() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        return {};
      }
    },
    gelbalancePL() {
      let data = this.openTradeList;
      let pl = 0;
      try {
        data.forEach((list) => {
          // pl += parseFloat(this.getPl(list,this.instruments[list.Symbol]))
          pl += parseFloat(
            this.getProfitLoss(
              this.accountList.Currency,
              list,
              this.instruments[list.Symbol],
              this.instruments,
              0
            )
          );
        });
        return parseFloat(pl.toFixed(2));
      } catch (e) {
        return 0;
      }
    },
    gelGrossPL() {
      let data = this.openTradeList;
      let pl = 0;
      try {
        data.forEach((list) => {
          // pl += parseFloat(this.getPl(list,this.instruments[list.Symbol]))
          pl += parseFloat(
            this.getProfitLoss(
              this.accountList.Currency,
              list,
              this.instruments[list.Symbol],
              this.instruments,
              1
            )
          );
        });
        return parseFloat(pl);
      } catch (e) {
        return 0;
      }
    },
  },
  methods: {
    getPrecisionValue(){
      if(this.accBalance && this.accBalance.ACCOUNT_CURRENCY=='BTC') return 8
      else return 2
    },
    performanceChart() {
      var _that = this;
      var chart = am4core.create("performanceChartDiv", am4charts.XYChart);

      // Add data
      // console.log('-----data', _that.portfolioData.summary.performanceChart)
      chart.data = _that.portfolioData.summary.performanceChart;

      // Create axes
      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.grid.template.disabled = true;
      dateAxis.renderer.line.disabled = true;

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      
      dateAxis.renderer.labels.template.fill = am4core.color(this.xAxisColor);
      dateAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color(this.yAxisColor);
      valueAxis.renderer.labels.template.fontSize = 12;
      // Create series
      function createSeries(field, name, hiddenInLegend) {
        var series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.name = name;
        if (hiddenInLegend) {
          series.stroke = am4core.color("#10BD72");
          series.fill = am4core.color("#10BD72");
        } else {
          series.stroke = am4core.color("#F25767");
          series.fill = am4core.color("#F25767");
        }
        series.tooltipText = "{dateX}: [b]{valueY}[/]";
        series.strokeWidth = 2;
        // if (hiddenInLegend) {
        //   	series.hiddenInLegend = true;
        // }
        return series;
      }

      var series1 = createSeries("equity", "Negative ");
      var series2 = createSeries("balance", "Positive", true);

      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      series1.legendSettings.labelText = "[{color}]{name}[/]";
      series2.legendSettings.labelText = "[{color}]{name}[/]";
      this.performanceChartData = chart;
    },
    equityBalanceChart() {
      var _that = this;
      var chart = am4core.create("equityBalanceChartDiv", am4charts.XYChart);

      // Add data
      // console.log('-----data',_that.weightchartData)
      chart.data = _that.portfolioData.summary.balanceEquityChart;

      // Create axes
      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;

      dateAxis.renderer.grid.template.disabled = true;
      dateAxis.renderer.line.disabled = true;

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      dateAxis.renderer.labels.template.fill = am4core.color(this.xAxisColor);
      dateAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color(this.yAxisColor);
      valueAxis.renderer.labels.template.fontSize = 12;

      // Create series
      function createSeries(field, name, hiddenInLegend) {
        var series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.name = name;
        if (hiddenInLegend) {
          series.stroke = am4core.color("#10BD72");
          series.fill = am4core.color("#10BD72");
        } else {
          series.stroke = am4core.color("#F25767");
          series.fill = am4core.color("#F25767");
        }
        // console.log(_that.accBalance.ACCOUNT_CURRENCY)
        // console.log('--->',_that.currencyIcon[_that.accBalance.ACCOUNT_CURRENCY])
        let currency = _that.currencyIcon[_that.accBalance.ACCOUNT_CURRENCY || localStorage.getItem('Account-Currency')];
        series.color = am4core.color("#4A881F");
        series.tooltipText = "{dateX.formatDate('dd,MMMM YY')} \n [b] "+ currency +"{valueY}[/]";
        series.strokeWidth = 2;
        // if (hiddenInLegend) {
        //   series.hiddenInLegend = true;
        // }

        // var bullet = series.bullets.push(new am4charts.CircleBullet());
        // bullet.circle.stroke = am4core.color("#fff");
        // bullet.circle.strokeWidth = 2;

        return series;
      }

      var series1 = createSeries("equity", "Equity");
      var series2 = createSeries("balance", "Balance", true);
      series1.legendSettings.labelText = "[{color}]{name}[/]";
      series2.legendSettings.labelText = "[{color}]{name}[/]";
      //var series3 = createSeries("value3", "Series #3", true);

      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
    },
    calculateVolume() {
      if (this.portfolioData.profitability.length > 0) {
        for (let i = 0; i <= this.portfolioData.profitability.length - 1; i++) {
          this.volumeSum += this.portfolioData.profitability[i].volume;
          this.tradeCount += this.portfolioData.profitability[i].count;

          this.totalPositive += this.portfolioData.profitability[i].positive;
          this.totalNegative += this.portfolioData.profitability[i].negative;

          if (i == this.portfolioData.profitability.length - 1) {
            // console.log(this.volumeSum,this.tradeCount)
          }
        }
      }
    },
    getBalance() {
      this._runGetAccBalance({ globalParams: {}, localParams: { parameter: this } });
    },
    getProfitLoss(accountCurrency, order, symbol, isins, grossPnL) {
      try {
        let quantity = order.Quantity;
        let commission = parseFloat(order.Commission ? order.Commission : 0);
        let interest = parseFloat(order.Interest ? order.Interest : 0);
        let price = parseFloat(order.Price);
        let askPrice = parseFloat(symbol.A);
        let bidPrice = parseFloat(symbol.B);
        let BSprice = 0;
        if (order.Side == 1) {
          BSprice = bidPrice - price;
        } else {
          BSprice = price - askPrice;
        }

        if (grossPnL == 1) {
          return parseFloat(
            (
              BSprice *
              quantity *
              parseFloat(
                this.convertCurrencyHKT(
                  accountCurrency,
                  symbol,
                  this.instruments,
                  order.Side
                )
              )
            ).toFixed(2)
          );
        } else {
          return parseFloat(
            (
              BSprice *
                quantity *
                parseFloat(
                  this.convertCurrencyHKT(
                    accountCurrency,
                    symbol,
                    this.instruments,
                    order.Side
                  )
                ) +
              (commission + interest)
            ).toFixed(2)
          );
        }

        // return parseFloat((BSprice * quantity) + (commission + interest)).toFixed(2);
      } catch (e) {
        // console.log(e);
        return 0;
      }
    },
    convertCurrencyNew(accountCurrency, symbol, isins, side) {
      symbol.other.base_currency = symbol.other.base_currency.split("_V")[0];

      if (accountCurrency == symbol.other.base_currency) {
        return 1;
      } else {
        const firstCurrency = accountCurrency.toUpperCase() + symbol.other.base_currency;

        if (isins[firstCurrency]) {
          return 1 / isins[firstCurrency].A;
        }

        const firstCurrencyWithSlash =
          accountCurrency.toUpperCase() + "/" + symbol.other.base_currency;

        if (isins[firstCurrencyWithSlash]) {
          return 1 / isins[firstCurrencyWithSlash].A;
        }

        const secondCurrency = symbol.other.base_currency + accountCurrency.toUpperCase();

        if (isins[secondCurrency]) {
          return isins[secondCurrency].A;
        }
        const secondCurrencyWithSlash =
          symbol.other.base_currency + "/" + accountCurrency.toUpperCase();

        if (isins[secondCurrencyWithSlash]) {
          return isins[secondCurrencyWithSlash].A;
        }
      }
    },

    convertCurrencyHKT(accountCurrency, symbol, isins, side) {
      symbol.other.base_currency = symbol.other.base_currency;

      if (accountCurrency == symbol.other.base_currency) {
        return 1;
      } else {
        const firstCurrency =
          accountCurrency.toUpperCase() + symbol.other.base_currency + product_type;

        // console.log("firstCurrency", firstCurrency);

        if (isins[firstCurrency]) {
          return 1 / isins[firstCurrency].A;
        }

        const firstCurrencyWithSlash =
          accountCurrency.toUpperCase() + "/" + symbol.other.base_currency + product_type;

        if (isins[firstCurrencyWithSlash]) {
          return 1 / isins[firstCurrencyWithSlash].A;
        }

        const secondCurrency =
          symbol.other.base_currency + accountCurrency.toUpperCase() + product_type;

        if (isins[secondCurrency]) {
          return isins[secondCurrency].A;
        }
        const secondCurrencyWithSlash =
          symbol.other.base_currency + "/" + accountCurrency.toUpperCase() + product_type;

        if (isins[secondCurrencyWithSlash]) {
          return isins[secondCurrencyWithSlash].A;
        }
      }
    },
    //===================================
    AddRemIndex(value) {
      if (this.indexNo == value) {
        this.indexNo = "";
      } else {
        this.indexNo = value;
      }
    },
    getPortfolioData() {
      this._runGetPortfoliosData({
        globalParams: { from_date: this.interval[this.currentInterval].from_date },
        localParams: { parameter: this },
      });
    },
  },
  created() {
    this.getPortfolioData();
  },
  mounted() {
    const _that = this;
    /*$(document).on("click", function(event){
				if(!$(event.target).closest('.openBuySell').length){
	                _that.buySell = ''
	                _that.tradeBuySell = false
	            }
	        });*/
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/user/portfolio-balance.vue